module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/vue2-google-maps/~/babel-runtime/~/core-js/library/modules/$.add-to-unscopables.js
// module id = 801
// module chunks = 0